import React from "react";

const RestaurentCard = ({ resName, price, cusion, time, rating, IMGSRC }) => {
  return (
    <div className="hover:border-2 hover:border-slate-950 hover:cursor-pointer  rounded-lg shadow-sm bg-[#f9f9f9] ">
      <div className="flex items-center justify-center">
        <img
          src={`https://media-assets.swiggy.com/swiggy/image/upload/${IMGSRC}`}
          alt="menu-item"
          className="py-2 px-1 rounded-xl opacity-95  w-72 h-52"
        />
      </div>

      <div className="flex flex-col  mx-2 flex-wrap">
        <h3 className="text-decor font-bold mx-1">{resName}</h3>
        {/* <p className="text-decor  text-gray-700 mx-1 ">{cusion.join(",")}</p> */}
        <p className="text-decor text-gray-700 mx-1">{price}</p>
        <div className="flex justify-between items-center mb-2">
          <p className="text-decor right-0 text-gray-700 mx-1 mb-2">
            {time} Minutes
          </p>
          <p className="text-decor bg-slate-900 px-2 rounded-full  text-white mx-1">
            {rating} Star
          </p>
        </div>
      </div>
    </div>
  );
};

// export const withPromotedLable = (RestaurentCard) => {
//   return ({ resName, price, cusion, time, rating, IMGSRC }) => {
//     return (
//       <div>
//         <label>Promoted</label>
//         <RestaurentCard
//           resName={resName}
//           price={price}
//           cusion={cusion}
//           time={time}
//           rating={rating}
//           IMGSRC={IMGSRC}
//         />
//       </div>
//     );
//   };
// };

export default RestaurentCard;
